// extracted by mini-css-extract-plugin
export default {"baseLayout":"styles_baseLayout__Cc7CD"};